<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">View/Upload Files</div>
        </div>
      </div>
      <form @submit.prevent="uploadImage">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <fg-image type="file"
                          v-on:file="updateSmallImg"
                          v-model="small_image"
                          label="Select File and Upload"
                          v-validate="rules.small_image"
                          data-vv-name="small image"
                          cus-name="small image"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-image>
              </div>
            </div>
          </div>
          <div class="col-6 text-center">
            <button type="submit" :disabled="smallNewImage.length === 0" class="btn btn-primary btn-fill btn-block">
              Upload
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
      <hr>
      <div class="table-responsive text-center">
        <l-table class="table table-light  table-light table-bordered table-hover"
                 :columns="imageColumns" :data="imageList">
          <template slot="table-row" v-if="imageList.length">
            <tr v-for="(item, index) in imageList" :key="index">
              <td>{{item}}</td>
              <td><img :src="item" alt="event-image" class="table-thumbnail"></td>
              <td>
                <div class="btn-group" role="group">
                  <button class="btn btn-danger btn-sm" @click="statusChange(item)"><i class="fa fa-toggle-off"></i></button>
                </div>
              </td>
            </tr>
          </template>
        </l-table>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import LTable from 'src/components/UIComponents/Table.vue'
  const imageColumns = ['Image URL', 'Image'];
  export default {
    name: 'fileupload',
    components: {
      LTable,
    },
    data () {
      let dateTime = new Date();
      return {
        imageColumns :['Image URL', 'Image'],
        imageList: [],
        largeNewImage: [],
        smallNewImage: [],
        interests:[],
        small_image: '',
        status: [{name:'Select an option'}, {active:true, name:'Active'}, {active:false, name:'Inactive'}],
        expert: {
          name: '',
          email: '',
          phone: '',
          active: '',
          experties: '',
          biography: '',
          areasofexpertise: '',
          small_image: '',
          large_image: '',
          interestName: ''
        },
        rules: {
          small_image: {required : true}
        },
        message: {
          error: false,
          text: ''
        }
      }
    },
    methods: {
      statusChange (item)  {
        console.log('item to be removed', item)
        this.$store.dispatch('REMOVE_IMAGE_FILE', item)
          .then((res) => {
            console.info('inside Remove')
            console.log("CREATE_EXPERT res : ", res);
            if(res) {
              this.showPopup('Success!', 'File is removed successfully', 'success')
              window.location.reload()
            }  else this.showPopup('Error!', 'Unable to process.', 'error')
          })
          .catch(err => {
            this.showPopup('Error!', 'File could not be uploaded', 'error')
            console.log("CREATE_EXPERT API error : ", err);
          })
      },
      uploadImage () {
            this.$store.dispatch('TOGGLE_LOADING', true);
            console.info('inside 1')
              this.$store.dispatch('UPLOAD_IMAGES', {
                small_image: this.smallNewImage[0]
              })
                .then((res) => {
                  console.info('inside 3')
                  console.log("CREATE_EXPERT res : ", res);
                  if(res) {
                    this.showPopup('Success!', 'File is uploaded successfully', 'success')
                      window.location.reload()
                  }  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'File could not be uploaded', 'error')
                  console.log("CREATE_EXPERT API error : ", err);
                })
//            createExpert();
            /*imageHelpers.upload({
             data: this.expert.large_image,
             file: this.largeNewImage[0]
             },
             (err, res) => {
             console.log("imageHelpers.upload err : ", err);
             console.log("imageHelpers.upload res : ", res);
             if(res){
             count++;
             this.expert.large_image = res.Location;
             if(count == 2) createExpert();
             }
             else this.$store.dispatch('TOGGLE_LOADING', false);
             });

             imageHelpers.upload({
             data: this.expert.small_image,
             file: this.smallNewImage[0]
             }, (err, res) => {
             console.log("imageHelpers.upload err : ", err);
             console.log("imageHelpers.upload res : ", res);
             if(res){
             count++;
             this.expert.small_image = res.Location;
             if(count == 2) createExpert();
             }
             else this.$store.dispatch('TOGGLE_LOADING', false);
             });*/
      },
      updateLargeImg(data){
        this.expert.large_image = data.path;
        this.largeNewImage = data.value;
        console.log("updateLargeImg data : ", data);
      },
      updateSmallImg(data){
        this.expert.small_image = data.path;
        this.smallNewImage = data.value;
        console.log("updateSmallImg data : ", data);
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      fetchImages () {
        this.imageList = []
        this.$store.dispatch('FETCH_IMAGES')
          .then((res) => {
            console.log(res)
            this.imageList = res;
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
      fetchInterests () {
        this.$store.dispatch('FETCH_INTERESTS')
          .then((res) => {
//                        res.unshift({name: "Select an option"});
            this.interests = res;
            console.log("this.interests : ", this.interests);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
    },
    created(){
      this.fetchImages();
    }
  }
</script>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ImageUpload.vue